<template>
<div>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="10" md="4">
      <v-card class="elevation-8 pt-12 pb-12 pl-6 pr-6">
        <v-img height="120" contain src="../../assets/Pelican_LogoB.png"></v-img>
        <br />
        <!--資料顯示方式-->
        <!--日期時間 + 貨物狀態/說明-->
        <table>
          <div v-for="n in dsmfilelst.length">
            <div v-if="n > 1">
              <div v-if="dsmfilelst[n-1].ds_id !== dsmfilelst[n-2].ds_id">
                <br /><b>
                  <div v-if="$cookie.get('dsmid_token').substr(1,2)==='01'">
                    <font face="微軟正黑體" size="4" color="#005a32">宅配單號：{{dsmfilelst[n-1].ds_id}}</font>
                  </div>
                  <div v-if="$cookie.get('dsmid_token').substr(1,2)==='11'">
                    <font face="微軟正黑體" size="4" color="#1976D2">宅配單號：{{dsmfilelst[n-1].ds_id}}</font>
                  </div>
                </b>
              </div>
            </div>
            <div v-else>
              <br /><b>
                <div v-if="$cookie.get('dsmid_token').substr(1,2)==='01'">
                  <font face="微軟正黑體" size="4" color="#005a32">宅配單號：{{dsmfilelst[n-1].ds_id}}</font>
                </div>
                <div v-if="$cookie.get('dsmid_token').substr(1,2)==='11'">
                  <font face="微軟正黑體" size="4" color="#1976D2">宅配單號：{{dsmfilelst[n-1].ds_id}}</font>
                </div>
              </b>
            </div>
            <br />
            <tr>
              <th width="160">{{dsmfilelst[n-1].current_time}}</th>
              <th>{{dsmfilelst[n-1].objstatus}}</th>
            </tr>
          </div>
        </table>
        <br />
        <font face="微軟正黑體" size="4" color="#FF5252">提醒您：僅限查詢近2個月內單號歷程</font><br />
        <br />
        <div v-if="btnshow===true">
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='01'">
            <v-btn color="success" @click="showcnee()">
              <font face="微軟正黑體" size="3">貨件資訊</font>
            </v-btn>
          </div>
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='11'">
            <v-btn color="primary" @click="showcnee()">
              <font face="微軟正黑體" size="3">貨件資訊</font>
            </v-btn>
          </div>
        </div>
        <div v-else>
          <div v-if="cnee===true">
            <br />
            <font face="微軟正黑體" color="#FF5252" size="4">若需要再次查詢，請重新掃描QRCODE</font>
            <!--Dialog_資訊安全政策說明-->
            <v-dialog v-model="dialog_Security" persistent max-width="600">
              <v-card>
                <v-card-title class="text-h5 primary">
                  <font color="#ECF5FF">資 訊 安 全 政 策 說 明</font>
                </v-card-title>
                <v-card-text>
                  </br>
                  台灣宅配通股份有限公司基於營運作業及公司政策之需要，提供物流宅配流程委外的服務。本公司以資訊科技為基礎，及專業的經驗與理念，為
                  企業量身訂做物流宅配流程委外服務模組，協助企業提升競爭力，創造優勢。因此，本公司資訊系統之資訊安全控管措施，在於保護客戶及交易
                  資料等資訊之機密性、完整性及可用性。同時強化資訊安全管理，確保資料、系統、設備及網路安全，以營造可靠的交易資訊環境、提昇資訊防
                  護技術、落實執行資訊安全管理作業；期以精益求精、不斷革新之精神，以提升優質服務而努力。基於此目標，本公司資訊安全政策聲明為：</br></br>
                  <center><b>
                      <font face="微軟正黑體" color="#FF5252" size="5">資 訊 安 全 ，人 人 有 責</font>
                    </b></center></br>
                  <font face="微軟正黑體" size="3">宅台灣宅配通隱私權政策</font></br>
                  大嘴鳥宅配通（即台灣宅配通股份有公司；以下簡稱本公司）因業務相關而且有必要性，並為提供客戶更完善服務，而為個人資料之蒐集、處理
                  或利用，本公司絕對遵守「個人資料保護法」及相關法令之規定，尊重當事人之權益、避免人格權受侵害，並且依誠實及信用方法為之，不逾越
                  特定目的之必要範圍，並與蒐集之目的具有正當合理之關聯。本公司就保護個人資料及隱私權之相關具體作法並說明如後。</br></br>
                  詳細內容</br>
                  壹、蒐集客戶資料之使用目的：</br>
                  一、貨件收受與配送。</br>
                  二、倉儲業務服務。</br>
                  三、電子商務相關之服務。</br>
                  四、產品銷售服務。</br>
                  五、客戶資料管理及相關服務。</br>
                  六、資訊與資料庫管理。</br>
                  七、人事業務。</br>
                  八、行銷及經營企劃相關分析。</br>
                  九、其他本公司依法得經營之業務。</br></br>
                  貳、客戶資料之蒐集範圍：</br>
                  依照客戶與本公司之間的具體關係，本公司將直接或間接經由業務合作對象取得以下資料：</br>
                  一、寄件人: 取得寄件人的姓名、地址、電話等託運所需資料。</br>
                  二、收件人: 從寄件人處取得收件人的姓名、電話、地址、代收貨款金額等資料。</br>
                  三、契約客戶: 取得契約客戶的姓名、地址、電話、國民身分證影本、電子信箱及存摺封面影本等及前項收件人之個人資料。</br>
                  四、公司會員: 取得會員的姓名、出生年月日、身分證統一編號、電話、地址及電子信箱等資料。</br>
                  五、應徵者及外包人員: 將從人力銀行或人力派遣公司取得應徵者及外包人員的履歷等相關資訊，該資訊可能包括：</br>
                  1.基本資料：包括姓名、出生年月日、身份證統一編號、電話、地址及電子信箱及親屬等資料。</br>
                  2.教育、技術或其他專業：包括學歷、資格或技術、專長等資料。</br>
                  3.工作經歷：包括現行工作情形、以前工作經驗等資料。</br>
                  六、除上述情形外，本公司如基於蒐集目的必要範圍內蒐集其他資料時，會另行告知蒐集內容。</br>
                  客戶有提供個人資料與否及範圍的選擇性。若客戶選擇拒絕提供該項個人資料或是提供不完整或是錯誤之資料時，將有可能無法提供客戶完善的服務。</br>
                  參、客戶資料之處理及利用範圍：</br>
                  一、除經客戶事先同意外，本公司僅會將自客戶取得的個人資料，使用在與客戶有關而提供的服務上。除了將貨件託運至國外的情形外，本公司只會在台灣地區內處理或利用客戶的個人資料。</br>
                  二、為提供完善的服務，本公司若有必要再委託予第三方(包含國內外業務合作對象或是其他運送人)之情形時，而本公司需將客戶個人資料
                  揭露予第三方者，該個人資料收受方，必需是有能力提供適當保護措施者。本公司亦將會對該個人資料收受方不定時進行查核及監督。</br>
                  肆、客戶資料之儲存方式及期間：</br>
                  一、本公司訂有嚴格的個人資料安全維護規定，本公司取得的個人資料將受嚴密、安全的保存。同時，任何人因業務相關，有必要進行資料
                  之取得與使用時，亦必需依安全維護規定為之。而與業務無關之任何人，均不得亦無法取得資料。</br>
                  二、除法令另有規定外，應徵資料應於面試後如確認不予錄用立即刪除、託運資料書面保存一年，掃描檔保留 400天，失效合約書除有特別
                  原因外保存一年。保存期間屆滿後將依法停止處理、利用或刪除。</br>
                  伍、客戶資料查詢、變更及刪除等之方式：</br>
                  一、客戶留存於本公司自己之個人資料，得依法向本公司以書面或電子文件請求行使查詢、補充、更正、閱覽、製給複製本；請求停止蒐集
                  、處理或利用；請求刪除等權利。惟前述權利，若因不符合法律規定或第二項之申請程序者，則不在此限。</br>
                  二、若客戶就註冊資料向本公司請求答覆、查詢、閱覽或製給複製本時，本公司得酌收必要成本費用。而前述之申請，應填具申請文件，本
                  公司得向客戶請求提出可資確認之身分證明文件，若委託他人代為申請者，並應出具委任書，且提供本人及代理人之身分證明文件。</br>
                  三、若客戶個人資料有變更，客戶可自行於本公司網頁進行更正。</br>
                  四、如果客戶不願意將個人資料提供予本公司或本公司之業務合作對象繼續使用，可致電本公司客服中心，本公司將停止使用客戶的個人資料。</br>
                  陸、資料安全及保護方法：</br>
                  一、本公司保有客戶個人資料檔案者，皆採行適當之安全措施，防止客戶個人資料被竊取、竄改、毀損、滅失或洩漏。</br>
                  二、對於客戶的個人資料，本公司以Secure Sockets Layer（SSL）機制進行加密傳輸，並加裝防火牆防止不法入侵，避免客戶個人</br>
                  柒：個人資料的揭露：</br>
                  除事先經過客戶的同意及下列情形外，本公司絕不會將客戶個人資料揭露予任何人。</br>
                  一、執行業務所需</br>
                  基於本公司為完成業務服務及達成前述蒐集及使用目的之需求，本公司會將部份工作委由外部服務提供者辦理，例如國內外之其他運送業者、業務合作對象、會計師、律師和其他專業顧問、客戶服務等。</br>
                  二、履行法定義務</br>
                  在以下必要的情況下，本公司有可能會將客戶的個人資料揭露予第三人：</br>
                  1. 司法單位或其他主管機關經合法正式的程序要求時。</br>
                  2. 其他依法辦理之事項。</br>
                  捌、諮詢事項：</br>
                  若客戶對於本公司隱私權政策或是對於個人資料蒐集、利用或處理有任何疑問。或者欲向本公司要求查詢或請求閱覽、製給複製本、補充或
                  更正、停止蒐集、處理或利用、刪除等事宜。</br></br>
                  若有上述需求，請於上班時間與本公司客服中心聯絡。</br>
                  一、服務時間：週一至週日08：30 - 19：00</br>
                  二、服務電話：(02)6618-1818</br>
                  三、聯絡電子信箱：service@e-can.com.tw</br></br>
                  隱私權政策之生效及修正：</br>
                  本隱私權政策自中華民國107年07月23日生效，但是為因應法令及社會環境之變遷，並為絕對保護您的個人資料安全及隱私權，本公司將定期檢視
                  並可能再修正隱私權政策。若有任何修正，本公司將會刊登於網站上公告週知。</br>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" x-large width="100" @click="btnSecurity()">
                    <font size="4">同 意</font>
                  </v-btn>
                  <v-btn color="warning" x-large width="100" @click="dialog_Security = false">
                    <font size="4">不同意</font>
                  </v-btn>
                </v-card-actions></br>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialog_Login" persistent max-width="600">
              <v-card>
                <v-card-title class="text-h5 primary">
                  <font color="#ECF5FF">使 用 者 登 入</font>
                </v-card-title>
                <v-card-text>
                  </br>
                  <b>
                    <font face="微軟正黑體" size="5" color="#1976D2">客戶代號：</font>
                  </b>
                  <v-text-field type="text" class="font-weight-bold" autofocus outlined clearable maxlength="10" v-model="username" :rules="usernameRules"></v-text-field>
                  <b>
                    <font face="微軟正黑體" size="5" color="#1976D2">密碼：</font>
                  </b>
                  <v-text-field :type="showpswd ? 'text':'password'" class="font-weight-bold" outlined v-model="password" :rules="passwordRules"></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" x-large width="100" @click="btnLogin()">
                    <font size="4">確 定</font>
                  </v-btn>
                  <v-btn color="primary" x-large width="100" @click="dialog_Login = false">
                    <font size="4">離 開</font>
                  </v-btn>
                </v-card-actions></br>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialog_cnee" persistent max-width="600">
              <v-card>
                <div v-if="$cookie.get('dsmid_token').substr(1,2)==='01'">
                  <v-card-title class="text-h5 success">
                    <font color="#ECF5FF">貨 件 資 訊</font>
                  </v-card-title>
                  <v-card-text>
                    </br>
                    <v-row class="mb-3" no-gutters>
                      <b>
                        <font face="微軟正黑體" size="5" color="#005a32">寄件人</font>
                      </b>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#005a32">姓&emsp;&emsp;名：{{this.start_name}}</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#005a32">電&emsp;&emsp;話：{{this.start_phone}}</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#005a32">地&emsp;&emsp;址：{{this.start_address}}</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <b>
                        <font face="微軟正黑體" size="5" color="#005a32">收件人</font>
                      </b>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#005a32">姓&emsp;&emsp;名：{{this.end_name}}</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#005a32">電&emsp;&emsp;話：{{this.end_phone}}</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#005a32">地&emsp;&emsp;址：{{this.end_address}}</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#005a32">寄件日期：</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#005a32">溫&emsp;&emsp;層：{{this.goods_type}}</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#005a32">件&emsp;&emsp;數：{{this.totobj}}</font>
                    </v-row>
                    <center>
                      <br /><b>
                        <font face="微軟正黑體" size="4" color="#FF5252">本視窗於{{timeNum}}後，自動關閉</font>
                      </b>
                    </center>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" x-large width="100" @click="dialog_cnee = false">
                      <font size="4">關 閉</font>
                    </v-btn>
                    &emsp;
                  </v-card-actions></br>
                </div>
                <div v-if="$cookie.get('dsmid_token').substr(1,2)==='11'">
                  <v-card-title class="text-h5 primary">
                    <font color="#ECF5FF">貨 件 資 訊</font>
                  </v-card-title>
                  <v-card-text>
                    </br>
                    <v-row class="mb-3" no-gutters>
                      <b>
                        <font face="微軟正黑體" size="5" color="#1976D2">寄件人</font>
                      </b>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#1976D2">姓&emsp;&emsp;名：{{this.start_name}}</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#1976D2">電&emsp;&emsp;話：{{this.start_phone}}</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#1976D2">地&emsp;&emsp;址：{{this.start_address}}</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <b>
                        <font face="微軟正黑體" size="5" color="#1976D2">收件人</font>
                      </b>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#1976D2">姓&emsp;&emsp;名：{{this.end_name}}</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#1976D2">電&emsp;&emsp;話：{{this.end_phone}}</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#1976D2">地&emsp;&emsp;址：{{this.end_address}}</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#1976D2">寄件日期：</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#1976D2">溫&emsp;&emsp;層：{{this.goods_type}}</font>
                    </v-row>
                    <v-row class="mb-3" no-gutters>
                      <font face="微軟正黑體" size="4" color="#1976D2">件&emsp;&emsp;數：{{this.totobj}}</font>
                    </v-row>
                    <center>
                      <br /><b>
                        <font face="微軟正黑體" size="4" color="#FF5252">本視窗於{{timeNum}}後，自動關閉</font>
                      </b>
                    </center>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" x-large width="100" @click="dialog_cnee = false">
                      <font size="4">關閉</font>
                    </v-btn>
                    &emsp;
                  </v-card-actions></br>
                </div>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialog_Error" persistent max-width="600">
              <v-card>
                <v-card-title class="text-h5 warning">
                  <font color="#ECF5FF">錯 誤 資 訊</font>
                </v-card-title>
                <v-card-text>
                  </br></br></br>
                  <center><b>
                      <font face="微軟正黑體" color="#FF5252" size="6">帳號或密碼錯誤</font>
                    </b></center>
                  </br>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="warning" x-large width="100" @click="dialog_Error = false">
                    <font size="4">離 開</font>
                  </v-btn>
                </v-card-actions></br>
              </v-card>
            </v-dialog>
          </div>
          <div v-else>
            <br />
            <font face="微軟正黑體" size="4">交寄超過30日，不顯示</font>
          </div>
        </div>
        <center>
          <br />
          <a href="https://www.e-can.com.tw/">
            <v-img height="80" contain src="../../assets/Pelican_IconLogo.png"></v-img>
          </a>
          <b>
            <font face="微軟正黑體" size="3" color="#555555">回官網</font>
          </b><br />
        </center>
      </v-card>
    </v-col>
  </v-row>
</div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      usernameRules: [
        (v) => !!v || " ",
        (v) => {
          if (!RegExp(/^[0-9]*$/).test(v)) {
            this.username = ''
          }
          return true
        },
      ],
      password: '',
      passwordRules: [
        (v) => !!v || " ",
      ],
      showpswd: false,
      dsmfilelst: [],
      cneelst: [],
      start_name: '',
      start_phone: '',
      start_address: '',
      end_name: '',
      end_phone: '',
      end_address: '',
      goods_type: '',
      totobj: '',
      inquiry_char: '',
      btnshow: true,
      cnee: true,
      dialog_Security: false,
      dialog_cnee: false,
      dialog_Login: false,
      dialog_Error: false,
      timeNum: 20,
      timer: null,
    };
  },
  watch: {
    dialog_cnee(val) {
      if (!val) return
      setTimeout(() => (
        this.dialog_cnee = false,
        this.start_name = '',
        this.start_phone = '',
        this.start_address = '',
        this.end_name = '',
        this.end_phone = '',
        this.end_address = '',
        this.goods_type = '',
        this.totobj = ''), 20000)
    },
  },
  mounted: function() {
    this.checkPage();
    this.serchDSM();
  },
  methods: {
    serchDSM: function() {
      //let url = 'https://queryapi.e-can.com.tw:9091/api/transdetail/main_id=' + this.$cookie.get('dsmid_token').substr(0, 12);
      let url = 'https://queryapi2.e-can.com.tw:9091/api/transdetail/main_id=' + this.$cookie.get('dsmid_token').substr(0, 12);
      this.$axios.get(url).then(response => {
        this.dsmfilelst = response.data.result;
      }).catch(function(error) {
        console.log(error);
      })
    },
    checkPage: function() {
      if (this.$cookie.get('page_token') != 'S') {
        this.$router.push({
          name: "ErrorPage"
        });
      } else {
        let page_token = 'O';
        this.$cookie.set('page_token', page_token, "0");
      }
    },
    showcnee: function() {
      if (this.btnshow === true) {
        this.btnshow = false;
        //let url = 'https://queryapi.e-can.com.tw:9091/EDIQRapi/EDIQR_Data/' + this.$cookie.get('dsmid_token').substr(0, 15);
        let url = 'https://queryapi2.e-can.com.tw:9091/EDIQRapi/EDIQR_Data/' + this.$cookie.get('dsmid_token').substr(0, 15);
        this.$axios.get(url).then(response => {
          this.cneelst = response.data;
          //判斷14日內資料
          if (this.cneelst.data[0].lentdate > this.data_daysago()) {
            //this.end_name = this.cneelst.data[0].end_name;
            //this.end_address = this.cneelst.data[0].end_addr;
            this.start_name = this.cneelst.data[0].start_name;
            this.start_phone = this.cneelst.data[0].start_phone + '/' + this.cneelst.data[0].start_telphone;
            this.start_address = this.cneelst.data[0].start_cityname + this.cneelst.data[0].start_areaname + this.cneelst.data[0].start_addr;
            this.end_name = this.cneelst.data[0].end_name;
            this.end_phone = this.cneelst.data[0].end_phone + '/' + this.cneelst.data[0].end_telphone;
            this.end_address = this.cneelst.data[0].end_cityname + this.cneelst.data[0].end_areaname + this.cneelst.data[0].end_addr;
            if (this.cneelst.data[0].goods_type === '01') {
              this.goods_type = '常溫';
            } else if (this.cneelst.data[0].goods_type === '02') {
              this.goods_type = '冷凍';
            } else if (this.cneelst.data[0].goods_type === '03') {
              this.goods_type = '冷藏';
            } else {
              this.goods_type = '';
            }
            this.totobj = this.cneelst.data[0].totobj;
            this.inquiry_char = this.cneelst.data[0].inquiry_char;
            this.cnee = true;
            this.dialog_Security = true;
          } else {
            this.cnee = false;
          }
        }).catch(function(error) {
          console.log(error);
        })
      } else {
        this.btnshow = true;
      }
    },
    data_daysago: function() {
      //20230104 文斌說將原本14天改成30天
      let date = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
      let year = date.getFullYear();
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      // 拼接
      return year.toString() + month.toString() + day.toString();
    },
    countdown: function() {
      this.timeNum--;
    },
    btnSecurity: function() {
      this.dialog_Security = false;
      this.dialog_Login = true;
      this.dialog_cnee = false;
    },
    btnLogin: function() {
      //let Custurl = 'https://queryapi.e-can.com.tw:9091/EDIQRapi/EDIQR_ChkCust/cust_id=' + this.username + '&pass=' + this.password + '&main_id=000000000000001'
      let Custurl = 'https://queryapi2.e-can.com.tw:9091/EDIQRapi/EDIQR_ChkCust/cust_id=' + this.username + '&pass=' + this.password + '&main_id=000000000000001'
      this.$axios.get(Custurl).then(response => {
        this.custfilelstCust = response.data;
        if (response.data.cust === '1') {
          this.dialog_Security = false;
          this.dialog_Login = false;
          this.dialog_cnee = true;
          this.timer = setInterval(this.countdown, 1000);
        } else {
          //alert('帳號密碼錯誤，請重新輸入');
          //this.password = '';
          this.dialog_Security = false;
          this.dialog_Login = false;
          this.dialog_cnee = false;
          this.dialog_Error = true;
        }
      }).catch(function(error) {
        this.$router.push({
          name: "ErrorPage"
        });
      })

    }

  },
};
</script>
